// 30-second cooldown gate for the OTC "send code" button.
//
// Each returned method takes an explicit `now` (epoch ms) argument - start(now), canSend(now),
// remainingSeconds(now) - so this stays a pure, clock-free state machine. The caller (e.g. the
// send-button component's own re-render tick) supplies Date.now().
export function createCooldownController (cooldownSeconds = 30) {
  let cooldownStartedAt = null

  function elapsedSeconds (now) {
    return (now - cooldownStartedAt) / 1000
  }

  return {
    start (now) {
      cooldownStartedAt = now
    },
    canSend (now) {
      if (cooldownStartedAt === null) return true
      return elapsedSeconds(now) >= cooldownSeconds
    },
    remainingSeconds (now) {
      if (cooldownStartedAt === null) return 0
      const remaining = cooldownSeconds - elapsedSeconds(now)
      return remaining > 0 ? Math.ceil(remaining) : 0
    }
  }
}
